<template>
    <div>
        <i :class="params.iconClass"/>
    </div>
</template>

<script>

export default {
    name: 'IconHeader',
}
</script>

<style lang="scss" scoped>
</style>